var map = {
	"./en/translation.json": 22830,
	"./es/translation.json": 6336,
	"./fr/translation.json": 75806,
	"./id/translation.json": 10251,
	"./it/translation.json": 463,
	"./ko/translation.json": 1557,
	"./pt-BR/translation.json": 28277,
	"./pt/translation.json": 85856,
	"./tr/translation.json": 44653
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 43473;